<template>
  <footer>
    <div class="container">
      <div class="credit-cards-logos">
        <img
          src="/img/mastercard-visa.png"
          alt="credit-card"
          class="credit-card-img"
        />
      </div>
      <div class="copyright">
        {{
          $t("footer.bottom.company_copyright", {
            year: new Date().getFullYear(),
          })
        }}
      </div>
      <div class="copyright">
        <router-link class="support-link item" :to="{ name: 'support' }">
          {{ $t("zammad_support.link") }}
        </router-link>
        |
        <router-link class="item" :to="{ name: 'faqs' }">
          {{ $t("header.faqs") }}
        </router-link>
        |
        <a :href="termsUrl" target="_blank">
          {{ $t("footer.items.legals.terms") }}
        </a>
        |
        <a :href="privacyUrl">
          {{ $t("footer.items.legals.privacy") }}
        </a>
        |
        <a :href="'mailto:soporte@divasplay.com'" target="_blank">
          {{ $t("footer.items.legals.complaints") }}
        </a>
      </div>
      <div class="developed_by">
        <a href="https://zedplan.com/" target="_blank">
          {{ $t("developed_by.title") }}
          <img
            decoding="async"
            src="https://cortesdemo.zedplan.pro/wp-content/uploads/2021/04/zedplan-2-e1618494788557.png"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import resources from "./../resources";

export default {
  computed: {
    privacyUrl() {
      return "https://divasplay.com/legals/privacy.html";
    },
    termsUrl() {
      let langCode = this.$i18n.locale;
      return `/legals/terms/${langCode}.html`;
    },
    complianceUrl() {
      let langCode = this.$i18n.locale;
      return `/legals/compliance/${langCode}.html`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables";

footer {
  padding: 20px;
  text-align: center;
  display: flex;
  color: #a8a8a8;

  a {
    font-weight: bold;
    text-decoration: underline;
  }

  @media (max-width: 960px) {
    flex-direction: column;
  }

  .copyright {
    @media (max-width: 960px) {
      text-align: center;
    }
  }

  .credit-cards-logos {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .credit-card-img {
    width: 20vw;
    height: auto;
    display: block;
    @media (max-width: 960px) {
      width: 80vw;
    }
  }

  .developed_by {
    display: flex;
    justify-content: center;
    margin-top: 0.5em;
    font-weight: bold;

    a {
      text-decoration: none;
      display: flex;
    }

    img {
      height: fit-content;
    }
  }
}
</style>
